module.exports = __webpack_public_path__ + "img/main-bg.1a4e71bb.png";